(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .factory('DiscSearch', DiscSearch);

    DiscSearch.$inject = ['$resource'];

    function DiscSearch($resource) {
        var resourceUrl =  'api/_search/discs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
